<template>
  <CommonApp />
</template>

<script lang="ts" setup>
useAppProvides()
</script>
